export default function triggerAnalyticsEvent(eventName, eventBody) {
  const analyticsEvent = new CustomEvent(eventName, { detail: eventBody })
  dispatchEvent(analyticsEvent)
}
